import React, { Fragment, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { MoreVert } from 'iconoir-react'
import moment from 'moment';
import 'moment/locale/vi'
import NotiTag from '../../components/NotiTag';
import TablePagination from '@mui/material/TablePagination';
import SkeletonNotification from './../../components/Skeleton/SkeletonNotification';
import { NOTIFICATION_STATUS } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { message } from 'antd';



const NotificationSystem = ({ notificationStore }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [items, setItems] = useState([])
    const [isFilterUnread, setIsFilterUnread] = useState(false)
    const [isLoadingNotification, setIsLoadingNotification] = useState(false)
    let only_news_notification = false;

    useEffect(() => {
        notificationStore.setFilter('notificationListPageIndex', page);
        notificationStore.setFilter('notificationListPageSize', rowsPerPage);
        (async () => {
            setLoading(true);
            try {
                await Promise.all([notificationStore.getCurrentUserNotification(only_news_notification)]);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [])
    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                await Promise.all([notificationStore.getCurrentUserNotification(only_news_notification)]);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [page || rowsPerPage])

    let notificationList = toJS(notificationStore.notificationList)
    let notificationListTotalCount = notificationStore.notificationListTotalCount

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        notificationStore.setFilter('notificationListPageIndex', newPage)
        notificationStore.setFilter('notificationListPageSize', rowsPerPage)
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
        notificationStore.setFilter('notificationListPageIndex', page);
        notificationStore.setFilter('notificationListPageSize', parseInt(event.target.value, 10));
    };
    // const getParameterByName = (name, url = window.location.href) => {
    //     name = name.replace(/[\[\]]/g, '\\$&')
    //     let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    //         results = regex.exec(url)
    //     if (!results) return null
    //     if (!results[2]) return ''
    //     return decodeURIComponent(results[2].replace(/\+/g, ' '))
    // };
    // const onlyNewsNotificationParams = getParameterByName(
    //     'only_news_notification'
    // )


    /** Xử lý đã đọc thông báo */
    const handleReadNotify = useCallback(
        (id, status, num) => {
            if (status && num === 0) {
                message.warning('Thông báo đã được đọc!')
                return
            }
            if (status) return
            setIsLoadingNotification(true)
            notificationStore
                .readNotification(id)
                .then(() => {
                    if (isFilterUnread) {
                        const itemsList = items.filter(el => el.id !== id)
                        setItems(itemsList)
                    } else {
                        const itemsList = [...items]
                        const indexReadItem = items.findIndex(item => item.id === id)
                        const itemReplace = {
                            ...items[indexReadItem],
                            status: true,
                        }
                        itemsList.splice(indexReadItem, 1, itemReplace)
                        setItems([...itemsList])
                    }
                    // if (onlyNewsNotificationParams === 'false') {
                    //     notificationStore.setUnreadNotificationCount('remove')
                    // } else {
                    //     notificationStore.setUnreadNewsCount('remove')
                    // }
                    message.success('Thông báo được đánh dấu đã đọc!')
                })
                .finally(() => setIsLoadingNotification(false))
        },
        [items]
    )


    const goToContentNotification = async (type, id) => {
        switch (type) {
            case NOTIFICATION_STATUS.OUTGOING:
                return navigate(`/internal-document/outgoing-document/view/${id}`)
            case NOTIFICATION_STATUS.INCOMING:
                return navigate(`/internal-document/incoming-document/view/${id}`)
            case NOTIFICATION_STATUS.WORK:
                return navigate(`/work/view/${id}`)
            default:
                return
        }
    }


    return (
        <div className='custom-pagination'>
            {loading ? (<SkeletonNotification />) : <Fragment>
                {notificationList?.map((item) => {
                    return <div className="relative bg-[#F8F8F8] rounded-lg p-3.5 mt-5" onClick={() => {
                        handleReadNotify(item.id, item.status, 1)
                        goToContentNotification(item.type, item.code)
                    }}>
                        {item.status === false ? <div className='absolute right-2 top-2 w-2 h-2 bg-[#0073C7] rounded-full' /> : ''}
                        {item.status === false ? <div className="font-bold text-sm" dangerouslySetInnerHTML={{ __html: item.content }} /> : <div className="text-sm" dangerouslySetInnerHTML={{ __html: item.content }} />}
                        <div className="my-3.5 flex justify-between">
                            <div className='text-xs mr-1'>
                                {moment(item.time_created).format('dddd', "vi")}, {moment(item.time_created).format("L")} lúc {moment(item.time_created).format('LT', "vi")}
                            </div>
                            <div className='text-xs font-[600]'>
                                bởi {item.owner}
                            </div>
                        </div>
                        <div className='flex justify-between'>
                            <NotiTag type={item.type} />
                            <div>
                                <MoreVert />
                            </div>
                        </div>
                    </div>
                })}
            </Fragment>}

            <TablePagination
                component="div"
                count={notificationListTotalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Số bản ghi"
            />
        </div>
    )
}

export default inject(
    "notificationStore"
)(observer(NotificationSystem));
